import React__default from 'react';
import classNames from 'classnames';
import Button from '../../Button/index.js';
import OutlineAngleRightMini from '../../icons/generated/outline/OutlineAngleRightMini.js';
var LoggedOutNavigation = function LoggedOutNavigation(_ref) {
  var links = _ref.links,
    loginLink = _ref.loginLink;
  function onLogin() {
    var link = loginLink || "https://app.consumidorpositivo.com.br";
    if (typeof window !== void 0) {
      var parameters = window.location.search;
      window.open(link + parameters, "_blank");
    }
  }
  function onClickItem(link) {
    if (typeof window !== void 0) {
      var parameters = window.location.search;
      window.location.href = link + parameters;
    }
  }
  return /* @__PURE__ */React__default.createElement("div", {
    className: "header-cp__logged-out-navigation"
  }, /* @__PURE__ */React__default.createElement("ul", {
    className: "header-cp__logged-out-navigation-list"
  }, links.map(function (_ref2, index) {
    var label = _ref2.label,
      href = _ref2.href,
      isActive = _ref2.isActive;
    return /* @__PURE__ */React__default.createElement("li", {
      key: "logged-out-navigation-list-item-".concat(index),
      className: classNames("header-cp__logged-out-navigation-list-item", {
        "header-cp__logged-out-navigation-list-item--active": !!isActive
      })
    }, /* @__PURE__ */React__default.createElement("div", {
      className: classNames("header-cp__logged-out-navigation-list-icon", {
        "header-cp__logged-out-navigation-list-icon--active": !!isActive
      })
    }, /* @__PURE__ */React__default.createElement(OutlineAngleRightMini, null)), /* @__PURE__ */React__default.createElement(Button, {
      type: "text",
      expand: "x",
      onClick: function onClick() {
        return onClickItem(href);
      },
      title: label,
      key: "desk-navigation-link-".concat(index)
    }, label));
  })), /* @__PURE__ */React__default.createElement("div", {
    className: "header-cp__auth-buttons"
  }, /* @__PURE__ */React__default.createElement("div", {
    className: "header-cp__auth-buttons__button"
  }, /* @__PURE__ */React__default.createElement(Button, {
    type: "secondary",
    expand: "x",
    justify: "center",
    onClick: onLogin
  }, "Entrar"))));
};
export { LoggedOutNavigation as default };